"use client";
import * as React from "react";
const SvgSpinnerRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8.726 2.009A6.027 6.027 0 0 0 7.863 14a1.004 1.004 0 0 1-.284 1.989A8.037 8.037 0 0 1 8.726 0a8.024 8.024 0 0 1 6.392 3.167 1.004 1.004 0 1 1-1.597 1.218 6.015 6.015 0 0 0-4.795-2.376Z", clipRule: "evenodd" }));
export {
  SvgSpinnerRound as default
};
